import { FormsInvitationResponse } from 'actions/formsInvitation/FormsInvitationDtos';

export interface FormsInvitationState {
    loading: boolean;
    data: FormsInvitationResponse | null;
    currentView: 'client' | 'pets' | 'success';
    answers: Record<string, { [questionId: number]: string | string[] }>;
    responseIds: Record<string, { [questionId: number]: number }>; // Maps questionId to ResponseData.id
    formResponseSetIds: Record<string, number>; // Maps formId or composite key to form_response_set id
    error: { code: number; message: string } | null;
    // Flags to track if notifications have been shown (to avoid showing again on back navigation)
    notifyAddQuestionShown: boolean;
    notifyAddPetShown: boolean;
}

export const formsInvitationInitialState: FormsInvitationState = {
    loading: true,
    data: null,
    currentView: 'client',
    answers: {},
    responseIds: {},
    formResponseSetIds: {},
    error: null,
    notifyAddQuestionShown: false,
    notifyAddPetShown: false
};
